const TAG = /<[^>]*>/g;
const NBSP = new RegExp(`&nbsp;|&#160;|${String.fromCharCode(160)}`, 'gi');
// A source `sanitizeProseHtml` keeps and the PDF draws: an http(s) link, an inline image, or a same-origin path.
const IMAGE_WITH_SOURCE = /<img\b[^>]*\ssrc\s*=\s*["']?(?:https?:|data:image\/|\/(?!\/))/i;

/**
 * True when rich-text HTML carries nothing visible — `''`, `<p></p>` (TipTap's empty document) or
 * paragraphs of spaces. A `{{token}}` counts as text, and so does an image: a body that is only a picture
 * (a page graphic) is content, not an empty body.
 */
export function isBlankProseHtml(html: string): boolean {
  if (IMAGE_WITH_SOURCE.test(html)) return false;
  return html.replace(TAG, '').replace(NBSP, ' ').trim() === '';
}
